import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet } from 'react-router-dom'

import { showNavBar, showSideBar } from '../../actions/commonActions'
import PortalTopBar from './PortalTopBar'

import classes from './PortalLayout.module.scss'

const PortalLayout = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(showSideBar(false))
    dispatch(showNavBar(false))

    return () => {
      dispatch(showSideBar(true))
      dispatch(showNavBar(true))
    }
  }, [dispatch])

  return (
    <div className={classes.portal}>
      <PortalTopBar />
      <Outlet />
    </div>
  )
}

export default PortalLayout
